import { useEffect, useState, useRef, useContext, createContext, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

import styles from "./IndEvent.module.css"
import guestii_gif from '../../assets/images/guestii_gif.gif'


export const PromoterLimits = ({ handleClose, settingLimits, toggledMenu=false, setTeamSelected=null, teamSelected=null, setMainReloadKey=null }) => {
  const param = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [limitsData, setLimitsData] = useState({});
  const intervalRef = useRef(null);
  const pressTimerRef = useRef(null);


  useEffect(() => {
    if (!toggledMenu) {
      const checkForLimits = Object.fromEntries([...settingLimits].map(({ value, limit = 0 }) => [ value, limit ]));
      setLimitsData(checkForLimits)
    } else {
      setLimitsData({ [toggledMenu.team_member._id]: toggledMenu.limit || 0 })
    }
  }, [])

  const handleForm = async (control, label, input) => {
    switch (control) {
      case 'submit':
        if (toggledMenu) {
          setIsLoading(true)

          const userId = localStorage.getItem("_id")
          const expiry = localStorage.getItem("expiry")
          if (!userId || !expiry) {
            localStorage.removeItem("_id")
            localStorage.removeItem("expiry")
            window.location = "/connect"
          }

          try {
            const body = {
              limit: limitsData[toggledMenu.team_member._id] || 0,
              team_member: toggledMenu.team_member._id
            }

            const res = await axios.post(`/api/events/update-promoter-limit/${param.event_id}`, body, {
              headers: {
                'x-user-id': userId,
                'x-expiry': expiry
              }
            });

            handleClose()
          } catch (err) {
            localStorage.removeItem("_id")
            localStorage.removeItem("expiry")
            window.location = "/connect"
          }

          setIsLoading(false)
        } else {
          setTeamSelected((prev) => {
            prev.forEach((t) => {
              t['limit'] = limitsData[t['value']] || 0
            })

            return prev
          })

          handleClose()
        }

        break;
    }
  }

  const increment = useCallback((id) => {
    setLimitsData((prev) => ({
      ...prev,
      [id]: (prev[id] || 0) + 1
    }));
  }, []);

  const decrement = useCallback((id) => {
    setLimitsData(prev => {
      const current = prev[id] || 0;
      if (current === 0) return prev;
      return {
        ...prev,
        [id]: current - 1
      };
    });
  }, []);

  const onPressStart = (id, plus = true) => {
    pressTimerRef.current = window.setTimeout(() => {
      plus ? increment(id) : decrement(id);
      intervalRef.current = window.setInterval(
        () => (plus ? increment(id) : decrement(id)),
        100
      );
    }, 500);
  };

  const onPressEnd = (id, plus = true) => {
    if (pressTimerRef.current) {
      clearTimeout(pressTimerRef.current);
      pressTimerRef.current = null;
      plus ? increment(id) : decrement(id);
    }

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  useEffect(() => () => {
    clearTimeout(pressTimerRef.current);
    clearInterval(intervalRef.current);
  }, []);

  return (
    <div className={`${styles.popup_container_ind_team}`}>
      {!isLoading
        ?
          <div className={styles.ratings_layout}>
            <button className={styles.ind_close_ind} onClick={() => handleClose(true)}><i className={`fa-solid fa-xmark ${styles.s1}`}></i></button>

            <div className={styles.new_banner}>
              <div className={styles.new_title}>
                <p className={styles.bold}>Set Promoter Limit</p>
                <p className={styles.s1}>Choose the amount of invites for promoters</p>
              </div>

              <div className={styles.banner_progress}>
                <div className={`${styles.progress_circle} ${styles.progress_circle_active}`}>
                  <i className={`fa-solid fa-star ${styles.m1}`}></i>
                </div>
              </div>
            </div>

            <div className={styles.limits_form_container}>
              <div className={styles.tags_warning}>
                <p className={styles.s1}>Limits are event specific. Team page shows all limits.</p>
              </div>


              <div
                style={{
                  height: '100%',
                  maxHeight: '100%',
                  overflowY: 'scroll',
                  position : 'relative',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                <div className={`${styles.table_container_indguestii} table_container`} style={{ gridTemplateColumns: '1fr', gridTemplateRows: `max-content` }}>
                  {settingLimits.map((t, n) => {
                    const lastItem = n === (settingLimits.length - 1);
                    const team_member = toggledMenu ? { ...t.team_member } : { ...t }
                    const team_member_id = toggledMenu ? toggledMenu.team_member._id.toString() : t.value

                    return (
                      <div className={`${styles.guestii_invited_ind_max} ${styles.no_hover}`}>
                        <div className={styles.guestii_inner_split}>
                          <div className={styles.guestii_profile_rounded}><i className={`fa-solid fa-user ${styles.s1}`}></i></div>

                          <div className={styles.guestii_profile_info}>
                            <p className={styles.s1}>{team_member.first_name} {team_member.last_name}</p>
                            <p className={styles.xs2}>{team_member.email}</p>
                          </div>
                        </div>

                        <div className={`${styles.widget_action_container_in} ${styles.numberInput}`}>
                          <label className={styles.xs3}>
                              Limit:
                          </label>

                          <div className={styles.customNumberInput}>
                            <button
                              className={`${styles.numberControl}`}
                              onMouseDown={() => onPressStart(team_member_id, false)}
                              onMouseUp={() => onPressEnd(team_member_id, false)}
                              onMouseLeave={() => onPressEnd(team_member_id, false)}
                              onTouchStart={() => onPressStart(team_member_id, false)}
                              onTouchEnd={() => onPressEnd(team_member_id, false)}
                            >
                              <i className={`fa-solid fa-minus ${styles.xs2}`}></i>
                            </button>

                            <input
                              type="number"
                              disabled={true}
                              value={limitsData[team_member_id] || 0}
                              className={`${styles.s1} ${(limitsData[team_member_id] === 0 || !limitsData[team_member_id]) && styles.hiddenValue}`}
                            />
                            {(limitsData[team_member_id] === 0 || !limitsData[team_member_id]) &&
                              <i className={`fa-solid fa-infinity ${styles.infinitySymbol} ${styles.s1}`}></i>
                            }

                            <button
                              className={`${styles.numberControl}`}
                              onMouseDown={() => onPressStart(team_member_id, true)}
                              onMouseUp={() => onPressEnd(team_member_id, true)}
                              onMouseLeave={() => onPressEnd(team_member_id, true)}
                              onTouchStart={() => onPressStart(team_member_id, true)}
                              onTouchEnd={() => onPressEnd(team_member_id, true)}
                            >
                              <i className={`fa-solid fa-plus ${styles.xs2}`}></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>

                <div className={`${styles.control_container} ${styles.control_last_item}`}>
                  <button onClick={() => handleForm('submit')} className={`${styles.control_btn} ${styles.next_btn}`}>
                    <i className={`fa-solid fa-check ${styles.m1}`}></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        :
          <div className={styles.loading_layout}>
            <img src={guestii_gif}/>
          </div>
      }
    </div>
  )
}